import { MAX_WIDTH } from "@/constant/Constant";
import useWindowSize from "@/hook/useWindowSize";
import LogoHeader from "@/pages/components/Headers/LogoHeader";
import { Box, Button, Grid, styled } from "@mui/material";
import { t } from 'i18next';
import RpIcon from "@/components/RpIcon";

const StyledBox = styled(Box)(({theme, width}) => {
  let backgroundPositionY;
  if (width <= 450) {
    backgroundPositionY = '-60px !important';
  } else if (width > 450 && width <= MAX_WIDTH) {
    backgroundPositionY = '-40vw !important';
  } else {
    backgroundPositionY = '-160px !important';
  }

  return {
    // background: 'url(/images/bind-bg.png) no-repeat',
    // backgroundSize: '100% auto',
    // backgroundPositionY: backgroundPositionY,
    minHeight: '100vh',
    position: 'relative',
    width: '100%',
  }
  //-40vw !important  
})

const StyledButtonWrapper = styled(Box)(({theme}) => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  maxWidth: MAX_WIDTH,
  textAlign: 'center',
}))

const StyledCategoryBox = styled(Box)(({theme}) => ({
  paddingTop: '320px',
  '.MuiGrid-item': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
  },
  'img': {
    width: '60px',
  },
  '.title': {
    fontSize: '12px',
    fontWeight: 400,
    padding: '6px 0',
    maxWidth: '100px',
    textAlign: 'center',
  }
}))

const StyledCardsBox = styled(Box)(({theme}) => ({
  paddingTop: '50px',
  '.title': {
    textAlign: 'center',
    color: '#E11D5C',
    fontSize: '20px',
    fontWeight: 700,
    padding: '16px 0',
    'img': {
      height: '16px',
      width: '30px',
    },
    'div': {
      display: 'inline-block',
      padding: '0 20px',
    }
  },
  '.MuiGrid-item': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    padding: '16px',
    'img': {
      width: '70px',
    },
    '.item-title': {
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 500,
      padding: '12px 0',
    },
    '.item-des': {
      textAlign: 'center',
      fontSize: '12px',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    }
  },
}))

function PromoView({ onGoTo }) {
  const {
    width,
  } = useWindowSize();

  return (
    <StyledBox width={width}>
      <LogoHeader showLanguageSelector />

      <div style={{ textAlign: 'center',padding:'16px' }}>
        <div style={{ fontSize: '24px', fontWeight: '700', padding: '6px 0' }}>{t('card_application')}</div>
        <div style={{ fontSize: '14px', fontWeight: '400', color: '#10051C99' }}>{t('card_application_des')}</div>
      </div>
      
      <StyledCategoryBox>
        <Grid container>
          <Grid item xs={4}>
            <img src={'/images/bind-icon-1.png'} />
            <div className="title">{t('spend_your_crypto_like_fiat')}</div>
          </Grid>
          <Grid item xs={4}>
            <img src={'/images/bind-icon-2.png'} />
            <div className="title">{t('use_globally_across_borders')}</div>
          </Grid>
          <Grid item xs={4}>
            <img src={'/images/bind-icon-3.png'} />
            <div className="title">{t('ultra_low_trans_costs')}</div>
          </Grid>
        </Grid>
      </StyledCategoryBox>

      <StyledCardsBox style={{ paddingBottom: '100px' }}>
        <div className="title">
          <img src={'/images/bind-text-dc.png'} />
          <div>
            {t('seamless_and_secure')}
          </div>
          <img src={'/images/bind-text-dc.png'} />
        </div>

        <Grid container>
          <Grid item xs={6}>
            <img src={'/images/card-icon-1.png'} />
            <div className="item-title">{t('two_factor_verification')}</div>
            <div className="item-des">{t('two_factor_verification_des')}</div>
          </Grid>
          <Grid item xs={6}>
            <img src={'/images/card-icon-2.png'} />
            <div className="item-title">{t('safety_pin')}</div>
            <div className="item-des">{t('safety_pin_des')}</div>
          </Grid>
          <Grid item xs={6}>
            <img src={'/images/card-icon-3.png'} />
            <div className="item-title">{t('trans_3ds_verification')}</div>
            <div className="item-des">{t('trans_3ds_verification_des')}</div>
          </Grid>
          <Grid item xs={6}>
            <img src={'/images/card-icon-4.png'} />
            <div className="item-title">{t('additional_security')}</div>
            <div className="item-des">{t('additional_security_des')}</div>
          </Grid>
        </Grid>
      </StyledCardsBox>

      <StyledButtonWrapper>
        <Button
          style={{ maxWidth: '200px', margin: '16px 0', borderRadius: '32px' }}
          variant="contained"
          size="large"
          fullWidth
          onClick={onGoTo}
        >
          {t("register_login")}
        </Button>
      </StyledButtonWrapper>
    </StyledBox>
  );
}

export default PromoView;
